import { render, staticRenderFns } from "./ChildAppUpgrade.vue?vue&type=template&id=6ad79c98&scoped=true"
import script from "./ChildAppUpgrade.vue?vue&type=script&lang=js"
export * from "./ChildAppUpgrade.vue?vue&type=script&lang=js"
import style0 from "./ChildAppUpgrade.vue?vue&type=style&index=0&id=6ad79c98&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad79c98",
  null
  
)

export default component.exports